import { useState } from 'react';
import { Link } from 'react-router-dom';

import useBrowserTabTitle from '../hooks/useBrowserTabTitle';

const ForgotPassword = () => {
    useBrowserTabTitle('Forgot Password')
    const [email, setEmail] = useState('');
    const [submitActive, setSubmitActive] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [error, setError] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault()

        setSubmitActive(true)

        fetch('/v0/forgot_password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: email
            })
        })
        .then(response => {
            if (response.ok) {
                setSubmitSuccess(true);
                setSubmitActive(false);
            } else {
                setError(true);
                setSubmitActive(false);
            }
        })
        .catch(error => {
            setError(true);
            setSubmitActive(false);
        })
    }
    
    let requiredIndicator = (<label className="form-required-star">&nbsp;*</label>);

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="text-center m-t-lg">
                        <h1>
                            Forgotten your password?
                        </h1>
                        <h1>
                        </h1>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-3">
                </div>
                <div className="col-lg-6">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            <div className="row">
                                <div className="col-sm-12">
                                    {submitSuccess &&
                                        <div>
                                            <h3 className="m-t-none m-b">Please check your email</h3>
                                            <p>
                                                An email has been sent to you at '{email}'.
                                            </p>
                                            <p>
                                                (If you don't get an email please check your spam mail folder and settings.)
                                            </p>
                                            <p>
                                                <Link to="/login" >Login</Link>
                                            </p>
                                        </div>
                                        ||
                                        <div>
                                            <h3 className="m-t-none m-b">Reset Password</h3>
                                            {error && <div className="alert alert-danger">Email address not recognised</div>}
                                            <form role="form" onSubmit={handleSubmit}>
                                                <div className="form-group">
                                                    Please enter your email address below to receive a password reset link
                                                </div>

                                                <div className="form-group">
                                                    <label>Email
                                                        {requiredIndicator}
                                                    </label> <input type="email" name="email" placeholder="Enter email" className="form-control" onChange={e => setEmail(e.target.value)} required/>
                                                </div>
                                                <div className="form-group">
                                                    <Link to="/login" >Login</Link>

                                                    <button className={'btn btn-mr btn-primary pull-right m-t-n-xs has-spinner ' + (submitActive ? 'active' : '')} type="submit">
                                                        <span className="psc-spinner"><i className="fa fa-refresh fa-spin fa-fw"></i></span>
                                                        Submit
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                </div>
            </div>
        </div>
    )
};

export default ForgotPassword
